import AuthGuard from './auth-guard'
import AntiAuthGuard from './anti-auth-guard'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout'

// Pages
import NotFound from '../components/GeneralViews/NotFoundPage'
import Login from 'Portal/components/Login/Login'
import ForgotPassword from 'Portal/components/ForgotPassword/ForgotPassword'

import AccountRoutes from './accountRoutes'
import UserRoutes from './userRoutes'
import OrderRoutes from './orderRoutes'

// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'Portal/components/Dashboard/Overview')

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: AntiAuthGuard
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword
    },
    {
        path: '/portal',
        name: 'portal',
        component: DashboardLayout,
        redirect: '/portal/dashboard',
        beforeEnter: AuthGuard,
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                component: Overview
            },
            // Insert sidebar group routes here
            ...UserRoutes,
            ...OrderRoutes,
            ...AccountRoutes
        ]
    },
    { path: '*', component: NotFound }
]

export default routes
